import { Link } from "wouter";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Home, Shield } from "lucide-react";

interface AdminHeaderProps {
  title: string;
  description?: string;
  showBackButton?: boolean;
}

export default function AdminHeader({ 
  title, 
  description, 
  showBackButton = true 
}: AdminHeaderProps) {
  return (
    <div className="mb-6 pb-6 border-b border-neutral-200">
      {showBackButton && (
        <div className="mb-4">
          <Link href="/admin">
            <Button variant="ghost" size="sm" className="gap-2">
              <ArrowLeft className="h-4 w-4" />
              Back to Admin Dashboard
            </Button>
          </Link>
        </div>
      )}
      <div className="flex items-center gap-3">
        <Shield className="h-8 w-8 text-primary" />
        <div>
          <h1 className="text-3xl font-bold text-neutral-900">{title}</h1>
          {description && (
            <p className="text-neutral-600 mt-1">{description}</p>
          )}
        </div>
      </div>
    </div>
  );
}